import { useState } from "react";
import { useMatch, useNavigate } from "react-router-dom";
import MoreHoriz from "@mui/icons-material/MoreHoriz";
import OpenInNew from "@mui/icons-material/OpenInNew";
import { Box, IconButton, Menu, MenuItem } from "@mui/material";
import FilterButton from "catalog/components/FilterButton";
import useCatalogSearch from "catalog/hooks/useCatalogSearch";
import queryString from "query-string";
import ContextualSearch from "~/components/ContextualSearch";
import { trackEvent } from "~/utils/monitoring";

const CatalogSearch = () => {
  const navigate = useNavigate();
  const datasetViewerOpen = useMatch("/data-browser/tables/:id");
  const [anchorEl, setAnchorEl] = useState<null | HTMLElement>(null);
  const columnListOpen = useMatch("/data-browser/columns");
  const tablesListOpen = useMatch("/data-browser/tables");

  const entityType = columnListOpen ? "column" : "table";
  const { isLoading, error } = useCatalogSearch(entityType);

  return (
    <Box display="flex" gap={1}>
      <Box width={250}>
        <ContextualSearch
          loading={isLoading && !error}
          submitCallback={({ query }) => {
            const search = queryString.stringify({ q: query });

            trackEvent("catalog_searched", {
              query,
              entity_type: tablesListOpen ? "table" : columnListOpen ? "column" : null,
            });

            if (datasetViewerOpen) {
              navigate({ pathname: "/data-browser/tables", search });
            }
          }}
        />
      </Box>
      <FilterButton />
      <Menu
        id="more-actions-menu"
        anchorEl={anchorEl}
        anchorOrigin={{
          vertical: "bottom",
          horizontal: "left",
        }}
        sx={{
          mt: 1,
        }}
        open={!!anchorEl}
        onClick={() => setAnchorEl(null)}
        onClose={() => setAnchorEl(null)}
        MenuListProps={{
          "aria-labelledby": "more-actions-btn",
        }}
      ></Menu>
    </Box>
  );
};

export default CatalogSearch;
